export const DateView = (
  date: Date | string | null | undefined,
  showTime = false
) =>
  date
    ? new Date(date).toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      ...(showTime && {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }),
    })
    : "";

